import { render, staticRenderFns } from "./UploadsPhotos.vue?vue&type=template&id=130c640e&scoped=true"
import script from "./UploadsPhotos.vue?vue&type=script&lang=js"
export * from "./UploadsPhotos.vue?vue&type=script&lang=js"
import style0 from "./UploadsPhotos.vue?vue&type=style&index=0&id=130c640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c640e",
  null
  
)

export default component.exports